module.exports = __webpack_public_path__ + "images/5e923a3087e53183ea3f4706bdc5c133-dw_logo_gradient.png";